import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-image',
  templateUrl: './project-image.component.html',
  styleUrls: ['./project-image.component.scss']
})
export class ProjectImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
